
export const GET_ADMIN_TICKETS = "GET_ADMIN_TICKETS"
export const GET_ADMIN_TICKETS_SUCCESS = "GET_ADMIN_TICKETS_SUCCESS"
export const GET_ADMIN_TICKETS_FAIL = "GET_ADMIN_TICKETS_FAIL"

export const GET_ADMIN_TICKET_DETAIL = "GET_ADMIN_TICKET_DETAIL"
export const GET_ADMIN_TICKET_DETAIL_SUCCESS = "GET_ADMIN_TICKET_DETAIL_SUCCESS"
export const GET_ADMIN_TICKET_DETAIL_FAIL = "GET_ADMIN_TICKET_DETAIL_FAIL"

export const UPDATE_TICKET_STATUS = "UPDATE_TICKET_STATUS"
export const UPDATE_TICKET_STATUS_SUCCESS = "UPDATE_TICKET_STATUS_SUCCESS"
export const UPDATE_TICKET_STATUS_FAIL = "UPDATE_TICKET_STATUS_FAIL"

export const REPLY_TICKET = "REPLY_TICKET"
export const REPLY_TICKET_SUCCESS = "REPLY_TICKET_SUCCESS"
export const REPLY_TICKET_FAIL = "REPLY_TICKET_FAIL"
